/* eslint-disable @typescript-eslint/no-non-null-assertion */
import { Temporal } from 'temporal-polyfill'

import { type CreateMovePayload } from '../../../../modules/moves'
import { recordToKeyValueMap } from '../../../../common/keyValueMap'
import { SpecialItem } from '../../../../common/specialItem'
import { type Room } from '../../../../common/residence'
import {
  MoveContent,
  type PreliminaryQuotesRequestPayload,
} from '../../../../modules/quotes'
import { type RegisterFormValues } from '../../../../components/forms/RegisterForm/RegisterForm.type'
import { type QuotesRequestFormValues } from '../QuotesRequestPage.type'
import { estimateRooms, getResidenceGeneralType } from '../../../../mwLib'

export const formatPreliminaryQuotesRequest = (formValues: QuotesRequestFormValues): PreliminaryQuotesRequestPayload => {
  const nbAppliances = formValues.moveSize.nbAppliancesAndMore ?? 0
  const nbTrucks = formValues.moveSize.nbTrucks

  const instant = Temporal.Instant.fromEpochMilliseconds(
    formValues.dateTime.movingDate.getTime(),
  )
  const zonedDateTime = instant.toZonedDateTimeISO(Temporal.Now.timeZoneId())
  const movingDate = zonedDateTime.toPlainDate().toString()

  return {
    ...formValues.addresses,
    ...formValues.dateTime,
    movingDate,
    request: {
      content: {
        specialItems: nbAppliances > 0
          ? [
              {
                key: SpecialItem.appliance,
                value: nbAppliances,
              },
            ]
          : undefined,
      },
      requirements: {
        nbMen: formValues.moveSize.nbMen,
        nbTrucks: recordToKeyValueMap(nbTrucks),
        movingLabourTime: formValues.moveSize.estimatedMovingLabourTime,
      },
    },
  }
}

type FormatMoveRequestOptions = {
  requestFormValues: QuotesRequestFormValues
  customerFormValues: RegisterFormValues
  queryString?: Record<string, string>
}

export const formatMoveRequest = ({
  requestFormValues,
  customerFormValues,
  queryString,
}: FormatMoveRequestOptions): CreateMovePayload => {
  const moveSize = requestFormValues.moveSize

  const {
    utm_source: utmSource,
    utm_medium: utmMedium,
    utm_campaign: utmCampaign,
  } = queryString ?? {}

  const movingFurniture = requestFormValues.moveSize.moveContent.includes(MoveContent.Furniture)
  const residenceRooms = movingFurniture ? estimateRooms(moveSize.residenceAndRoomsType) : undefined

  const baseValues = formatPreliminaryQuotesRequest(requestFormValues)

  return {
    ...baseValues,
    customer: customerFormValues,
    request: {
      ...baseValues.request,
      residence: {
        residenceType: getResidenceGeneralType(moveSize.residenceAndRoomsType)!,
        residenceRooms: residenceRooms ? recordToKeyValueMap<Room, number>(residenceRooms) : undefined,
      },
      content: {
        ...baseValues.request.content as any,
        nbBoxes: moveSize.nbBoxes ?? 0,
        furnitureRatio: moveSize.furnitureRatio ?? 0,
      },
      size: {
        volumeCubicFeet: moveSize.volumeCubicFeet,
        weightPounds: moveSize.weightPounds,
      },
    },
    source: {
      utmSource,
      utmMedium,
      utmCampaign,
    },
  }
}
